import React from "react";
import "./RequestStatusComponents.css";

export function RequestStatusBanner({ label, backgroundColor, textColor }) {
  return (
    <div className="request-status-main-div" style={{ backgroundColor }}>
      <p className="request-status-text" style={{ color: textColor }}>
        {label}
      </p>
    </div>
  );
}

export function RequestOpen() {
  return (
    <RequestStatusBanner
      label="Open Request"
      backgroundColor="green"
      textColor="#ffffff"
    />
  );
}

export function RequestComplete() {
  return (
    <RequestStatusBanner
      label="Request Complete"
      backgroundColor="orange"
      textColor="#ffffff"
    />
  );
}

